import React from 'react';
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image"
import { useStaticQuery, graphql } from "gatsby";
import styled from '@emotion/styled'
import { parseHTML } from '../../functions/common'
import * as breakpoint from '../../styles/breakpoints.module.scss';

const PageHeadline = ({ category, title, subtitle, bgImg, date, type }) => {

  const data = useStaticQuery(graphql`
    query PageHeadline {
      background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_general.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      background_tablet : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_general_tablet.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
      background_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_pageHeader_general_mobile.jpg"}) {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: NONE
          )
        }
      }
    }
  `);

  const defaultBg = withArtDirection(getImage(data.background), [
    {
      media: `(min-width: ${breakpoint.mdMin})`,
      image: getImage(data.background),
    },
    {
      media: `(max-width: ${breakpoint.smMax}) and (min-width: ${breakpoint.smMin})`,
      image: getImage(data.background_tablet),
    },
    {
      media: `(max-width: ${breakpoint.xsMax})`,
      image: getImage(data.background_mobile),
    }
  ])
  return(
  <HeaderWrapper>
    <TextWrapper type={type}>
      <CategoryText>{category}</CategoryText>
      <TitleText>{parseHTML(title)}</TitleText>
      {date &&
      <DateText>{date}</DateText>}
      {subtitle && 
      <SubtitleText>{parseHTML(subtitle)}</SubtitleText>}
    </TextWrapper>
    <Background>
      <GatsbyImage image={bgImg ? bgImg : defaultBg} objectFit={'cover'} alt={"bg"}/>
    </Background>
  </HeaderWrapper>)
}

export default PageHeadline;

const HeaderWrapper = styled.div`
  position:relative;
  min-height:536px;
  .gatsby-image-wrapper{
    height: 100%
  }

  display:flex;
  align-items:flex-end;
  justify-content:center;

  @media only screen and (max-width: ${breakpoint.smMax}){
    min-height:480px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    min-height:360px;
  }
`

const TextWrapper= styled.div`
  width:928px;
  /*position:absolute;
  transform: translateX(-50%);
  left:50%;*/
  z-index:2;
  //bottom:0;
  //height:392px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  max-width:100%;
  padding-top:160px;
  padding-bottom:114px;

  
  text-align:${props => props.type === "post" ? "left" : "center"};
  
  @media only screen and (max-width: ${breakpoint.smMax}){
    
    padding:140px 80px 125px;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){

    padding:125px 24px 85px;
  }
`

const CategoryText = styled.div`
  font-weight: 900;
  font-size: 18px;
  line-height: 32px;
  letter-spacing: 0.1em;
  color: #D00F31;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.03em;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.03em;
  }
`

const TitleText = styled.h1`
  font-weight: 900;
  font-size: 56px;
  line-height: 72px;
  margin:0;
  letter-spacing: 0.1em;

  color: #222224;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 44px;
    line-height: 60px;
    letter-spacing: 0.03em;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 28px;
    line-height: 40px;
    letter-spacing: 0.03em;
  }
`
const DateText = styled.div`
font-weight: 900;
font-size: 18px;
line-height: 28px;
letter-spacing: 0.1em;
color: #4E4E50;
margin-top:8px;

@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
}
`

const SubtitleText = styled.div`
font-weight: 900;
font-size: 18px;
line-height: 28px;
letter-spacing: 0.1em;
color: #4E4E50;
margin-top:8px;

@media only screen and (max-width: ${breakpoint.smMax}){
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  margin-top:6px;
}
@media only screen and (max-width: ${breakpoint.xsMax}){
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.03em;
  margin-top:4px;
}
`
const Background = styled.div`
  width:100%;
  height:100%;
  position:absolute;
`
